import React from 'react';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="21"
      fill="none"
      viewBox="0 0 17 21"
    >
      <g filter="url(#filter0_d)">
        <path
          fill="#fff"
          d="M5.055 9.313a.644.644 0 000 .902l5.304 5.332c.274.246.684.246.93 0l.629-.629c.246-.246.246-.656 0-.93L7.707 9.75l4.211-4.21c.246-.274.246-.685 0-.93l-.629-.63c-.246-.246-.656-.246-.93 0L5.055 9.312z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          width="15.232"
          height="19.936"
          x="0.87"
          y="0.796"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
